import api from '../../api'
import dayjs from 'dayjs'
export default {
  data () {
    return {
      map: null,
      mapLoad: true,
      marker: null,
      polyline: null,
      // 充电热力
      chargeMap: null,
      // 轨迹热力
      trackMap: null,
      // 污染物热力
      disChargeMap: null,
      GPS: {
        PI: 3.14159265358979324,
        x_pi: 3.14159265358979324 * 3000.0 / 180.0,
        delta: function (lat, lon) {
          // Krasovsky 1940
          //
          // a = 6378245.0, 1/f = 298.3
          // b = a * (1 - f)
          // ee = (a^2 - b^2) / a^2;
          var a = 6378245.0 //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
          var ee = 0.00669342162296594323 //  ee: 椭球的偏心率。
          var dLat = this.transformLat(lon - 105.0, lat - 35.0)
          var dLon = this.transformLon(lon - 105.0, lat - 35.0)
          var radLat = lat / 180.0 * this.PI
          var magic = Math.sin(radLat)
          magic = 1 - ee * magic * magic
          var sqrtMagic = Math.sqrt(magic)
          dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * this.PI)
          dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * this.PI)
          return { 'lat': dLat, 'lon': dLon }
        },

        // GPS---高德
        gcj_encrypt: function (wgsLat, wgsLon) {
          if (this.outOfChina(wgsLat, wgsLon)) {
            return { 'lat': wgsLat, 'lon': wgsLon }
          }

          var d = this.delta(wgsLat, wgsLon)
          return { 'lat': wgsLat - 0 + d.lat, 'lng': wgsLon - 0 + d.lon }
        },
        outOfChina: function (lat, lon) {
          if (lon - 72.004 < 0 || lon - 137.8347 > 0) {
            return true
          }
          if (lat - 0.8293 < 0 || lat - 55.8271 > 0) {
            return true
          }
          return false
        },
        transformLat: function (x, y) {
          var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
          ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0
          ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0
          ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0
          return ret
        },
        transformLon: function (x, y) {
          var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
          ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0
          ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0
          ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0
          return ret
        }
      }
    }
  },
  props: {
    path: {
      type: Array,
      default () {
        return []
      }
    }
  },
  mounted () {
    this.initMap()
  },
  methods: {
    // 初始化地图
    initMap () {
      // const self = this
      const AMap = window.AMap
      this.map = new AMap.Map('detail-map', {
        zoom: 10, // 地图显示的缩放级别
        center: [106.397428, 37.90923], // 地图中心点坐标值
        mapStyle: 'amap://styles/darkblue',
        viewMode: '2D'
      })
      // 初始化地图的时候也要初始化热力图
      this.map.plugin(['AMap.Heatmap'], () => {
        // 充电热力
        this.chargeHeatMap()
        // 轨迹热力
        this.trackHeatMap()
        this.disChargeHeatMap()
        // 设置数据
        this.setHeatData()
      })
    },
    // 充电热力
    chargeHeatMap () {
      // 初始化热力图
      this.chargeMap = new window.AMap.Heatmap(this.map, {
        radius: 25, // 热力图中单个点的半径
        opacity: [0, 0.8] // 热力图透明度数组
      })
      this.chargeMap.hide()
    },
    // 轨迹热力
    trackHeatMap () {
      // 初始化热力图
      this.trackMap = new window.AMap.Heatmap(this.map, {
        radius: 25, // 给定半径
        opacity: [0, 0.8]
      })
      this.trackMap.hide()
    },
    disChargeHeatMap () {
      // 初始化热力图
      this.disChargeMap = new window.AMap.Heatmap(this.map, {
        radius: 25, // 热力图中单个点的半径
        opacity: [0, 0.8] // 热力图透明度数组
      })
      this.disChargeMap.hide()
    },
    // 设置热力图数据
    setHeatData (queryParams) {
      const self = this

      // 时间截止到前一天
      let lastDay = new Date() - 1000 * 60 * 60 * 24
      let parmas = {}
      let date = dayjs(lastDay).format('YYYY-MM-DD')
      parmas.vid = queryParams || self.$route.query.vid
      parmas.date = date
      const getHeatData = async function () {
        // 获取轨迹热力图
        // 获取单车充电热力图
        const ChargeGeo = await api.getChargeGeoCoord(parmas)
        self.chargeMap.setDataSet({
          data: ChargeGeo.data.data.map(d => {
            return {
              lng: d.wgLon,
              lat: d.wgLat,
              count: 1
            }
          }),
          max: 100
        })
        const RunGeo = await api.getRunGeoCoord(parmas)
        // 设置热力图展现的数据集
        // let pathD = []
        self.trackMap.setDataSet({
          data: RunGeo.data.data.map((d, i) => {
            // let { lat, lng } = self.GPS.gcj_encrypt(d[2503], d[2502])
            let lat = d[2503]
            let lng = d[2502]
            if (lat && lng) {
              return {
                lng: lng, // 经度
                lat: lat, // 纬度
                count: d.count
              }
            } else {
              return {
                lng: RunGeo.data.data[i - 1][2502], // 经度
                lat: RunGeo.data.data[i - 1][2503], // 纬度
                count: RunGeo.data.data[i - 1].count
              }
            }
          }),
          max: 100
        })
        // 污染物排放
        const DisChargeGeo = await api.getDisChargeGeo(parmas)
        self.disChargeMap.setDataSet({
          data: DisChargeGeo.data.data.map((d, i) => {
            // let { lat, lng } = self.GPS.gcj_encrypt(d[2503], d[2502])
            let lat = d[2503]
            let lng = d[2502]
            if (lat && lng) {
              return {
                lng: lng, // 经度
                lat: lat, // 纬度
                count: d.count
              }
            } else {
              return {
                lng: RunGeo.data.data[i - 1][2502], // 经度
                lat: RunGeo.data.data[i - 1][2503], // 纬度
                count: RunGeo.data.data[i - 1].count
              }
            }
          }),
          max: 100
        })
      }
      getHeatData()
    },
    // 顶部的搜索
    search (type, inner) {
      if (!inner) return
      const params = {}
      switch (type) {
        case '1':
          params.licensePlate = inner
          break
        case '2':
          params.vin = inner
          break
      }
      api.getVehicleInfo(params).then(resp => {
        const data = resp.data.data
        if (resp.data.meta.code === -1) {
          this.$message({
            message: resp.data.meta.message,
            type: 'success'
          })
          return
        }
        this.$emit('setCar', data)
        // 要重新设置热力数据
        this.setHeatData(data.vid)
      }).catch(e => {})
    },
    // 判断是否显示哪个图层
    showWhichMap (val) {
      // 0 车辆位置
      // 1 充电热力
      // 2 新能源轨迹热力
      // 5 燃油车轨迹热力
      // 4 污染物热力
      switch (val) {
        case 0:
          this.trackMap && this.trackMap.hide()
          this.chargeMap && this.chargeMap.hide()
          this.polyline && this.polyline.show()
          this.marker && this.marker.show()
          this.map.setFitView()
          break
        // 充电热力
        case 1:
          this.polyline && this.polyline.hide()
          this.marker && this.marker.hide()
          this.chargeMap && this.chargeMap.show()
          this.trackMap && this.trackMap.hide()
          break
        // 轨迹热力
        case 2:
          this.polyline && this.polyline.hide()
          this.marker && this.marker.hide()
          this.chargeMap && this.chargeMap.hide()
          this.trackMap && this.trackMap.show()
          break
        // 5 轨迹热力应该和 2 是一样
        case 5:
          this.polyline && this.polyline.hide()
          this.marker && this.marker.hide()
          this.chargeMap && this.chargeMap.hide()
          this.trackMap && this.trackMap.show()
          break
        case 4:
          this.polyline && this.polyline.hide()
          this.marker && this.marker.hide()
          this.chargeMap && this.chargeMap.hide()
          this.trackMap && this.trackMap.hide()
          this.disChargeMap && this.disChargeMap.show()
          break
      }
    }
  },
  watch: {
    // 生成地图marker点与行驶轨迹
    path (path) {
      if (!this.map) return
      const AMap = window.AMap
      path.forEach(element => element.lat !== null)
      console.log('pathpath', path)
      const point = path[path.length - 1]
      if (this.polyline) {
        this.polyline.setPath(path)
      } else {
        this.polyline = new AMap.Polyline({
          map: this.map,
          path: path,
          showDir: true,
          strokeColor: '#28F',
          strokeWeight: 6
        })
      }
      if (!point) return
      if (this.marker) {
        this.marker.setPosition(point)
      } else {
        this.marker = new AMap.Marker({
          map: this.map,
          position: point
        })
      }
      this.map.setCenter(this.marker.getPosition())
      // 判断是否显示哪个地图
      this.showWhichMap(this.isActive)
    },
    // 对选择了哪个图进行监听
    isActive (val) {
      this.showWhichMap(val)
    }
  }
}
